import React from "react";
import "./Styles.scss";

const Loader = () => {
  return (
    <div className="loading">
      <div className="circles-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
